import { Component, Input } from '@angular/core';
import { PtEntity } from '@pt/pt-models';
import { WorkspaceItemType } from '@primatoo-ms-organization';

@Component({
  selector: 'pt-image-renderer',
  template: `
    <div class="pt-image-cell-renderer" [ngClass]="cssClass">
      <ng-content select="[additionalContentLeft]"></ng-content>
      <div *ngIf="locked" class="locked-image">
        <img
          [ngbTooltip]="tooltip"
          container="body"
          [width]="width"
          src="assets/images/workspace/locked.svg"
          alt=""
        />
      </div>

      <ng-container [ngSwitch]="type" *ngIf="showIcon">
        <!-- Entities -->
        <ng-container *ngSwitchCase="'FOLDER'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/workspace/folder.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'INTERNAL_LE'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/entities/legalEntity.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'ENTITY'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="entity"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'AI_ASSESSMENT'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'aiAssessment'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'APPLICATIONS'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'applications'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'APPLICATION_ASSESSMENT'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'appAssessment'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'APP_ASSESSMENT'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'appAssessment'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'DPIA'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'dpia'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'ATTACHMENT'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/entities/attachment.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'GLOBAL_MEASURE_CHECK'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'globalMeasureCheck'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'COVID_ASSESSMENT'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'covidAssessment'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'TREATMENT'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/workspace/treatment.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'TREATMENT_HOLDER'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsHolder'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <!--        VALIDATED-->
        <ng-container
          *ngSwitchCase="WorkspaceItemType.COVID_ASSESSMENT_VALIDATED"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'covidAssessmentValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container *ngSwitchCase="WorkspaceItemType.AI_ASSESSMENT_VALIDATED">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'aiAssessmentValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.APP_ASSESSMENT_VALIDATED"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'appAssessmentValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.TREATMENT_PROJECT_VALIDATED"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'projectCardsValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.TREATMENT_SUB_RESPONSIBLE_VALIDATED"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsSubResponsibleValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.TREATMENT_RESPONSIBLE_VALIDATED"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsResponsibleValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.TREATMENT_HOLDER_VALIDATED"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsHolderValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.GLOBAL_MEASURE_CHECK_VALIDATED"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'riskAssessmentValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <!--        END VALIDATED-->

        <!--        SNAPSHOT-->
        <ng-container
          *ngSwitchCase="WorkspaceItemType.COVID_ASSESSMENT_SNAPSHOT"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'covidAssessmentValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container *ngSwitchCase="WorkspaceItemType.AI_ASSESSMENT_SNAPSHOT">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'aiAssessmentValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container *ngSwitchCase="WorkspaceItemType.APP_ASSESSMENT_SNAPSHOT">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'appAssessmentValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.TREATMENT_PROJECT_SNAPSHOT"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'projectCardsValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.TREATMENT_SUB_RESPONSIBLE_SNAPSHOT"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsSubResponsibleValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.TREATMENT_RESPONSIBLE_SNAPSHOT"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsResponsibleValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.TREATMENT_HOLDER_SNAPSHOT"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsHolderValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container
          *ngSwitchCase="WorkspaceItemType.GLOBAL_MEASURE_CHECK_SNAPSHOT"
        >
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'riskAssessmentValidated'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <!--        END SNAPSHOT-->

        <ng-container *ngSwitchCase="'HOLDER'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsHolder'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'TREATMENT_RESPONSIBLE'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsResponsible'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'RESPONSIBLE'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsResponsible'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'TREATMENT_SUB_RESPONSIBLE'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsSubResponsible'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'SUB_RESPONSIBLE'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'treatmentsSubResponsible'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'TREATMENT_PROJECT'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'projectCards'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'PROJECT'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'projectCards'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchCase="'APPOINTMENTS'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'appointments'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <!-- files -->

        <ng-container *ngSwitchCase="'PDF'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/icon-svg/pdf.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'XLS'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/icon-svg/xls.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'XLSX'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/icon-svg/xlsx.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'CSV'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/icon-svg/csv.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'JPG'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/icon-svg/jpg.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'PNG'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/icon-svg/png.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'TXT'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/icon-svg/txt.svg"
            alt=""
          />
        </ng-container>

        <ng-container *ngSwitchCase="'APPLICATION'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'applications'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container *ngSwitchCase="'RECIPIENT'">
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/entities/recipients.svg"
            alt=""
          />
        </ng-container>
        <ng-container *ngSwitchCase="'APPOINTMENT_AUTH'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'appointments'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container *ngSwitchCase="'APPOINTMENT_RESP'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'appointments'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>
        <ng-container *ngSwitchCase="'APPOINTMENT_SYS_ADM'">
          <pt-entity-icon
            [ngbTooltip]="tooltip"
            container="body"
            [entity]="'appointments'"
            [width]="width"
          ></pt-entity-icon>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <img
            [ngbTooltip]="tooltip"
            container="body"
            [width]="width"
            src="assets/images/workspace/default.svg"
            alt=""
          />
        </ng-container>
      </ng-container>

      <ng-content select="[additionalContent]"></ng-content>

      <span
        class="ms-1 pt-image-cell-renderer-label"
        [ngClass]="labelClass"
        *ngIf="label"
        >{{ label }}</span
      >

      <ng-content select="[additionalContentRight]"></ng-content>
    </div>
  `,
  styles: [
    `
      .locked-image img {
        height: 15px;
        margin-top: -5px;
      }

      .pt-image-cell-renderer {
        display: flex;
        align-items: center;
      }

      .pt-image-cell-renderer-label {
        width: -webkit-fill-available;
      }

      pt-entity-icon {
        margin-top: -0.25rem;
      }

      img {
        position: relative;
      }

      img > * {
        margin-right: 8px;
      }

      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    `,
  ],
})
export class ImageRendererComponent {
  @Input() type: WorkspaceItemType | string; // | DashboardItem | string;
  @Input() entity: PtEntity;
  @Input() label: string;
  @Input() locked = false;
  @Input() width = 18;
  @Input() labelClass: string;
  @Input() cssClass: string;
  @Input() showIcon = true;
  @Input() tooltip?: string;
  WorkspaceItemType = WorkspaceItemType;
}
